/**
 * @generated SignedSource<<9c2bdcf1e8d532d1bd29e006b558cfa8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type utils_useNoteHasRecordings_note$data = {
  readonly meetingRecordings: ReadonlyArray<{
    readonly id: string;
  }> | null;
  readonly " $fragmentType": "utils_useNoteHasRecordings_note";
};
export type utils_useNoteHasRecordings_note$key = {
  readonly " $data"?: utils_useNoteHasRecordings_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"utils_useNoteHasRecordings_note">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "utils_useNoteHasRecordings_note",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MeetingRecording",
      "kind": "LinkedField",
      "name": "meetingRecordings",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Note",
  "abstractKey": null
};

(node as any).hash = "7c7466f09b780e8437e063ff95a6acb0";

export default node;
